import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-8ff7e406"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "password_wrap"
};
var _hoisted_2 = {
  class: "pass"
};
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h1", null, "请输入密码", -1);
});
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return $setup.password = $event;
    }),
    class: "pass_input",
    placeholder: "请输入密码"
  }, null, 512), [[_vModelText, $setup.password]]), _createElementVNode("div", {
    class: "true_btn",
    onClick: _cache[1] || (_cache[1] = function () {
      return $setup.handleTrueClick && $setup.handleTrueClick.apply($setup, arguments);
    })
  }, "确定")])]);
}